import { IResource } from "../i18n";

// tslint:disable-next-line: variable-name
const translation_it: IResource = {
    feedback_button_text: "Invia",
    feedback_cta_0_3: "Siamo davvero spiacenti, ti preghiamo di dirci cosa dovremmo risolvere",
    feedback_cta_4_6: "È un peccato, ci dirai cosa migliorare?",
    feedback_cta_7_8: "Cosa possiamo fare per renderlo migliore?",
    feedback_cta_9_10: "Fantastico! Puoi dirci l'unica cosa che ti è piaciuta di più?",
    feedback_mail_subject: "Feedback dell'applicazione Meet",
    feedback_text_legend: "Siamo ugualmente grati per il feedback sia negativo che positivo",
    feedback_text_title: "Fornisci il tuo feedback qui (facoltativo)",
    feedback_title_finished: "Il tuo Meet è finito",
    feedback_title_ongoing: "Aiutaci a migliorare Meet",
    feedback_title_question: "Con quale probabilità consiglieresti di incontrare un amico o un collega?",
    feedback_value_best: "Molto probabilmente",
    feedback_value_worst: "Per niente probabile",

    onboarding_button_jointext: "Partecipa Meet",
    onboarding_description_four: "Pulsante.",
    onboarding_description_one: "Come primo utente, puoi personalizzare il modo in cui gli altri ti vedranno su Meet.",
    onboarding_description_three: "ISCRIVITI A  MEET",
    onboarding_description_two: "Una volta pronto, basta fare clic su",
    onboarding_label_color: "Colore",
    onboarding_label_consentAgree: "Sono d'accordo con Meet",
    onboarding_label_consentPrivacy: "Politica sulla riservatezza",
    onboarding_label_consentAnd: "e",
    onboarding_label_consentTermsOfUse: "Condizioni d'uso",
    onboarding_label_darkTheme: "Tema scuro",
    onboarding_label_firstName: "Il tuo nome (facoltativo)",
    onboarding_label_green: "Verde",
    onboarding_label_indigo: "Indaco",
    onboarding_label_lastName: "Il tuo cognome (facoltativo)",
    onboarding_label_lightTheme: "Tema leggero",
    onboarding_label_orange: "Arancia",
    onboarding_label_pink: "Rosa",
    onboarding_label_purple: "Viola",
    onboarding_label_teal: "Teal",
    onboarding_label_theme: "Tema",
    onboarding_label_yellow: "Giallo",
    onboarding_title: "Nice to Meet you!",

    invite_legend_text: "Invia questo link a una persona che desideri durante la chiamata",
    invite_link_copy: "Copia link",
    invite_link_defaultCopied: "Link copiato negli appunti!",
    invite_link_email: "Invito via e-mail",
    invite_link_label: "URL del tuo invito",
    invite_link_sms: "Invito SMS",
    invite_mail_body: "Ciao, ti prego, unisciti al mio incontro!",
    invite_mail_signature: "Saluti",
    invite_mail_subject: "Il link di partecipazione di Meet",
    invite_title_text: "INVITA QUALCUNO AL TUO MEET",

    citypicker_label: "Città",
    citypicker_nomatch: "Nessuna posizione corrispondente",

    userprofile_city_label: "Città",
    userprofile_color_label: "Colore",
    userprofile_email_label: "Indirizzo email",
    userprofile_label_green: "Verde",
    userprofile_label_indigo: "Indaco",
    userprofile_label_orange: "Arancia",
    userprofile_label_pink: "Rosa",
    userprofile_label_purple: "Viola",
    userprofile_label_teal: "Teal",
    userprofile_label_yellow: "Giallo",
    userprofile_locale_label: "Lingua",
    userprofile_name_label: "Nome di battesimo",
    userprofile_surname_label: "Cognome",
    userprofile_theme_label: "Tema",
    userprofile_themedark_label: "Tema scuro",
    userprofile_themelight_label: "Tema leggero",

    options_tab_profile: "Profilo",

    consentdialog_button_cancel: "Annulla",
    consentdialog_button_ok: "OK",

    layout_meet_end: "Chiudi Meet",
    layout_meet_leave: "Esci da Meet",

    layout_sidebar_labelClose: "Chiudi il menu della barra laterale",
    layout_sidebar_labelOpen: "Apri il menu della barra laterale    ",
    layout_sidebar_labelTitle: "Apri il menu della barra laterale",
    layout_title_text: "Meet | Interviste senza attrito",

    layout_toolbar_enter: "Accedi a schermo intero",
    layout_toolbar_invite: "Invita",
    layout_toolbar_invite_tooltip: "Invita altre persone a questo incontro",
    layout_toolbar_leave: "Lascia a schermo intero",

    layout_dialog_descriptionEnd: "Questo terminerà il Meet per tutti i partecipanti",
    layout_dialog_titleEnd: "Sei sicuro di voler chiudere questo Meet?",
    layout_dialog_titleLeave: "Sei sicuro di voler lasciare questo Meet?",

    layout_dialog_descriptionLeave: "Questo NON finirà Meet for altri partecipanti",
    layout_sidebar_explorer: "Guida",
    layout_sidebar_feedback: "Condividi feedback",
    layout_sidebar_settings: "Impostazioni",

    layout_finish_endmeet: "Terminare l'attuale Meet",
    layout_finish_leavemeet: "Uscire dall'attual Meet ",

    layout_cta_register: "Hai bisogno di un incontro gratuito di 60 minuti?",
    layout_cta_register_tooltip: "Iscriviti per un credito gratuito di $10",

    layout_dialog_descriptionAbandon: "Sembra che tu sia l'unico in questa chiamata",
    layout_dialog_titleAbandon: "Vuoi finire questo Meet?",

    language_en_title: "English",
    language_srLatn_title: "Srpski",
    language_srCyrl_title: "Српски",
    language_fr_title: "Français",
    language_es_title: "Español",
    language_it_title: "Italian",
    language_de_title: "Deutsche",
    language_pl_title: "Polski",

    meeting_finished_title: "RIUNIONE FINITA",
    meeting_finished_tooltip: "Accesso in sola lettura",

    layout_reactivate_button: "Riattiva Meet",
    layout_reactivate_tooltip: "Fai clic qui se desideri riaprire e utilizzare questo Meet finito",
    layout_dialog_titleReactivate: "Sei sicuro di voler riattivare questo Meet?",
    layout_dialog_descriptionReactivate: "Questo riaprirà il Meet per l'adesione, la modifica e altre modifiche",

    toast_reconnecting_title: "Chiamata problema di segnalazione",
    toast_reconnecting_message: "Connessione (stato: {state}) persa a causa dell'errore {error}. Riconnessione ...",
    toast_reconnected_title: "Chiamata di segnalazione",
    toast_reconnected_message: "Connessione ristabilita. Stato: {state}",
    toast_disconnected_title: "Errore di segnalazione della chiamata",
    toast_disconnected_message: "{state}) chiuso per un errore {error}." +
                                "Prova ad aggiornare questa pagina per rilanciare la connessione.",

    config_title_text: "Crea nuovo Meet",
    config_title_ctaOne: "Per favore, definisci gli elementi di un nuovo Meet che vuoi creare.",
    config_title_ctaTwo: "Tutti i dati di input sono facoltativi e possono essere omessi.",
    config_title_label: "Title",
    config_description_label: "Descrizione",
    config_duration_label: "Durata",
    config_tool_label: "Strumenti di incontro",
    config_tool_call: "Meet video call",
    config_tool_editor: "Editor di codice",
    config_tool_whiteboard: "Whiteboard",
    config_passcode_label: "Incontra passcode (se presente)",

    search_placeholder_text: "Inserisci i criteri di ricerca",
    createMeeting_button_create: "Crea Meet",

    projectboard_scheduleinfo_none: "La riunione non ha una data di inizio definita, quindi può essere utilizzata in qualsiasi momento",
    projectboard_scheduleinfo_anytime: "In qualsiasi momento",

    projectboard_join_anyone: "Chiunque abbia un link può unirsi",
    projectboard_role_guest: "Ospite",
    projectboard_role_interviewee: "Candidato",
    projectboard_role_interviewer: "Intervistatore",
    projectboard_role_organizer: "Organizzatore",

    projectboard_status_draft: "In bozza",
    projectboard_status_scheduling: "Pianificazione",
    projectboard_status_schedulingFailed: "Pianificazione fallita",
    projectboard_status_pending: "In attesa",
    projectboard_status_ready: "Pronto",
    projectboard_status_starting: "Di partenza",
    projectboard_status_inprogress: "In corso",
    projectboard_status_onhold: "In attesa",
    projectboard_status_completed: "Completato",
    projectboard_status_canceled: "Annullato",
    projectboard_status_archived: "Archiviato",
    projectboard_status_feedbackWait: "In attesa di un feedback",
    projectboard_status_feedbackDone: "Feedback raccolto",
    projectboard_status_feedbackFail: "Raccolta feedback non riuscita",

    projectboard_status_stopped: "Fermato",

    minibar_dashboard_title: "Cruscotto",
        
    layout_sidebar_rateus: "Votaci",

    invite_passcode_label: "Codice",

    invite_text_copy: "Copia invito",

    invite_text_body: "Si prega di aderire al mio Meet at {url}",
    
    invite_passcode_body: "Si prega di unirsi al mio Meet a {url} e utilizzare il codice di accesso {passcode}",

    invite_text_copied: "Il testo dell'invito Meet viene copiato negli Appunti.",

    invite_pascode_add: "Aggiungi passcode all'URL",
        
    participant_join_message: "{participant} aveva partecipato alla riunione.",
    participant_left_message: "{participant} aveva lasciato la riunione.",
        
    minibar_dashboard_tooltip: "Gestisci le tue interviste",

    layout_sidebar_snapshot: "Istantanea",

    snapshots_none_text: "Scatta una o più istantanee dell'editor di codice e della lavagna e rivedile dopo il Meet.",
    snapshot_toast_text: "Istantanea scattata",
    snapshots_cta_text: "Scatta un'istantanea (F9)",
    snapshot_sentiment_positive: "Istantanea positiva",
    snapshot_sentiment_negative: "Istantanea negativa",
    snapshot_sentiment_note: "Nota",
    
    snapshot_personal_value: "Istantanea personale",
    snapshot_personal_title: "Visibile solo a te",
    snapshot_team_value: "Istantanea di squadra",
    snapshot_team_title: "Visibile solo alla tua squadra.",
    snapshot_public_title: "Visibile a tutti i partecipanti",
    snapshot_public_value: "Istantanea pubblica",

    snapshots_live_text: "Torna all'intervista dal vivo",

    snapshot_action_delete: "Elimina",
    snapshot_action_load: "Carica istantanea",
    
    snapshot_delete_dialog_title: "Elimina istantanea?",
    snapshot_delete_dialog_description: "Si prega di confermare che si desidera eliminare questa istantanea",
    snapshots_final_back: "Torna allo stato Meet end",
};

export default translation_it;
